import { z } from 'zod';

export const reviewSchema = z
  .object({
    review_id: z.number(),
    order_id: z.number(),
    order_token: z.string(),
    review_type: z.object({
      id: z.number(),
      name: z.string(),
    }),
    rating: z.number(),
    comment: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
    restaurant: z.object({
      restaurant_id: z.number(),
      name: z.string(),
      address: z.string(),
      city: z.string(),
      state: z.string(),
      zip: z.string(),
      status: z.boolean(),
      full_address: z.string(),
    }),
    user: z.object({
      name: z.string(),
      email: z.any(),
      phone_number: z.any(),
    }),
  })
  .strict();

export type Restaurant = z.infer<typeof reviewSchema>;

export const reviewsServiceDataSchema = z.object({
  total_pages: z.number(),
  current_page: z.number(),
  previous_page: z.any(),
  next_page: z.any(),
  items_per_page: z.number(),
  total_data: z.number(),
  status: z.number(),
  success: z.boolean(),
  rating: z.object({
    average_rating: z.string(),
    count: z.number(),
  }),
  data: z.array(reviewSchema),
});
